import * as types from '../../mutation-types'
import axios from "axios";

export const loadPaymentMethods = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/v1/user/payment-methods')
        commit(types.FETCH_PAYMENT_METHODS_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_PAYMENT_METHODS_FAILURE)
    }
};

export const savePaymentMethod = async ({ commit }, formData) => {
    await axios.post(process.env.API_URL + '/v1/user/payments', formData)
};

export const removePaymentMethod = async ({ commit }, formData) => {
    await axios.post(process.env.API_URL + '/v1/user/remove-payment', formData)
};

export const loadIntentToken = async ({ commit }) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/v1/user/setup-intent')
        commit(types.FETCH_INTENT_TOKEN_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_INTENT_TOKEN_FAILURE)
    }
};

export const updateSubscription = async ({ commit }, formData) => {
    await axios.put(process.env.API_URL + '/v1/user/subscription', formData)
}

export const fetchSubscription = async ({ commit }, userId) => {
    try {
        const { data } = await axios.get(process.env.API_URL + '/v1/user/fetch-subscription/'+ userId)
        commit(types.FETCH_PLAN_ID_SUCCESS, { data })
    } catch (e) {
        commit(types.FETCH_PLAN_ID_FAILURE)
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/api/actions.js